
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';

const HydrogenApproachSection = () => {
  return (
    <section className="relative overflow-hidden" style={{ backgroundColor: 'rgb(214, 234, 247)' }}>
      <div className="flex flex-col lg:flex-row">
        {/* Left column with hydrogen molecule image - full edge-to-edge */}
        <div className="lg:w-1/2">
          <img 
            src="/lovable-uploads/50a4b66a-0e14-4a42-b068-1796db96afab.png" 
            alt="Hydrogen molecule H2" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Content column */}
        <div className="lg:w-1/2 flex flex-col justify-center px-4 md:px-7 py-12 md:pr-9">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold mb-4">Investir dans l'hydrogène</h2>
          
          <p className="text-lg mb-4" style={{ color: '#001c4b' }}>
            Notre stratégie d'investissement cible la chaîne de valeur complète de l'hydrogène à travers 4 piliers essentiels:
          </p>
          
          <ul className="mb-4 space-y-2 list-disc pl-5">
            <li className="text-lg" style={{ color: '#001c4b' }}>Production d'énergie renouvelable</li>
            <li className="text-lg" style={{ color: '#001c4b' }}>Technologies et composants</li>
            <li className="text-lg" style={{ color: '#001c4b' }}>Production, stockage et distribution</li>
            <li className="text-lg" style={{ color: '#001c4b' }}>Utilisateurs finaux</li>
          </ul>
          
          <p className="text-lg mb-6" style={{ color: '#001c4b' }}>
            Notre approche responsable exclut les sociétés aux comportements controversés tout en visant une meilleure intensité carbone.
          </p>
          
          <Link to="/bilan-patrimonial">
            <Button className="bg-patrimoine-gold hover:bg-amber-500 text-black font-medium py-3 px-6 rounded-md transition-all duration-300 shadow-lg">
              Obtenir mon bilan patrimonial
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HydrogenApproachSection;
